const fieldAffComm = [
    {colMd: "6", label: "Commission", required: true, type: "select", name: "commission", placeholderData: ["Select Commission"]},
    {colMd: "6", label: "Fixed Cost", required: true, type: "text", name: "fixed_cost"},
];

const fieldValuesComm = {
    commission: '',
    fixed_cost: '',
};

const fieldValidationComm = {
    commission: 'required||Commission',
    fixed_cost: 'required|digit:|min:1|max:4||Fixed Cost', 
};

const fieldValuesConfig = {
    sponsor: '',
    commission: '',
    fixed_cost: '',
    comments: ''
};

const fieldAffConfig =  [
    {colMd: "6", label: "Sponsor", required: false, type: "text", name: "sponsor"},
    {colMd: "6", label: "Commission", required: false, type: "select", name: "commission", placeholderData: ["Select Commission"]},
    {colMd: "6", label: "Fixed Cost", required: false, type: "text", name: "fixed_cost"},
    {colMd: "6", label: "Comments", required: false, type: "text", name: "comments"}
];

const fieldValidationConfig = {
    commission: 'optional||Commission',
    fixed_cost: 'optional|digit:|min:1|max:4||Fixed Cost', 
    sponsor : 'optional|max:100||Sponsor',
    comments : 'optional|max:250||Comments'
};

const optionComm = [
    {id: 0, label: '0%'},
    {id: 5, label: '5%'},
    {id: 10, label: '10%'},
    {id: 15, label: '15%'},
    {id: 20, label: '20%'},
    {id: 25, label: '25%'},
    {id: 30, label: '30%'},
    {id: 35, label: '35%'},
    {id: 40, label: '40%'},
    {id: 45, label: '45%'},
    {id: 50, label: '50%'},
    {id: 55, label: '55%'},
    {id: 60, label: '60%'},
];

const data = {
    fieldValuesComm,
    fieldValidationComm,
    fieldAffComm,
    fieldAffConfig,
    fieldValuesConfig,
    fieldValidationConfig,
    optionComm
};
  
export default data;